import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';

/**
 * TitleMetaService.
 */
@Injectable()
export class TitleMetaService {
  /** App favicon, adaptable for Brands */
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');

  /**
   * Constructor.
   * @param titleService
   * @param metaService
   */
  constructor(private titleService: Title,
              private metaService: Meta) {
  }

  /**
   * Sets the title for the page.
   * @param title
   */
  public setTitle(title: string) {
    this.titleService.setTitle(title);
  }

  /**
   * Sets the metadata.
   * @param definition
   * @param selector
   */
  public setMeta(definition: MetaDefinition, selector: string = null) {
    if (selector && this.metaService.getTag(selector)) {
      this.metaService.updateTag(definition, selector);
    } else {
      this.metaService.addTag(definition);
    }
  }

  /**
   * Needed:
   * In the component which uses the method: favIcon: HTMLLinkElement = document.querySelector('#favIcon');
   * In index.html add the id:   <link rel="icon" id="favIcon" type="image/x-icon" href="assets/icon-hires.png">
   * @param favIcon
   * @param href
   */
  public setFaviconHref(favIcon: HTMLLinkElement, href: string) {
    favIcon.href = href;
  }
}
